import styledComponents from 'styled-components'

export default styledComponents.p.attrs({ className: 'is-5' })``



// WEBPACK FOOTER //
// ./src/components/views/typo/Text.js